/**
 * Maps raw Supabase/auth error messages to user-friendly messages.
 */
const ERROR_MAP: [RegExp, string][] = [
  [/email link is invalid or has expired/i, 'This email is already registered. Try signing in with your email and password, or use a different sign-in method.'],
  [/invalid login credentials/i, 'Incorrect email or password. Please try again.'],
  [/email not confirmed/i, 'Please check your inbox and confirm your email before signing in.'],
  [/user already registered/i, 'An account with this email already exists. Try signing in instead.'],
  [/signup is disabled/i, 'New sign-ups are currently disabled. Please try again later.'],
  [/rate limit/i, 'Too many attempts. Please wait a moment and try again.'],
  [/same_password/i, 'New password must be different from your current password.'],
  [/password.*too.*short|at least.*characters/i, 'Password must be at least 8 characters long.'],
  [/refresh token/i, 'Your session has expired. Please sign in again.'],
  [/nonce/i, 'Sign-in verification failed. Please try again.'],
];

export function getFriendlyAuthError(rawMessage: string): string {
  for (const [pattern, friendly] of ERROR_MAP) {
    if (pattern.test(rawMessage)) {
      return friendly;
    }
  }
  return rawMessage;
}
